/**
 * Syncing row state — progress % + ETA. Reuses the existing elapsed-vs-
 * last-duration heuristic (pages/QueueJobsPage) rather than inventing a
 * second one; there is no server-pushed percent, this is the proven pattern
 * already shipped for queue jobs.
 */
import React from "react";
import QueueJobProgress from "../QueueJobsPage/QueueJobProgress";
import QueueJobToDuration from "../QueueJobsPage/QueueJobToDuration";
import LoadingIndicator from "../../component/LoadingIndicator";
import styles from "./ConnectionRow.module.scss";

const SyncProgressBar = ({ integration }) => {
  const hasLastImport = Boolean(integration?.last_import);
  const syncTime = new Date((integration.modified || Date.now() / 1000) * 1000);

  const job = {
    data: { last_duration: integration?.last_import?.duration || 0 },
    created: syncTime,
    fetched: syncTime,
    completed: null,
    progress: 0,
  };

  return (
    <div className={styles.stripWrap}>
      <div className={styles.progressLabel}>
        Syncing…{" "}
        {hasLastImport ? (
          <QueueJobToDuration job={job} asPercentage showETA />
        ) : (
          "Initial sync, please wait…"
        )}
      </div>
      {hasLastImport ? (
        <QueueJobProgress job={job} />
      ) : (
        <LoadingIndicator className={styles.progressIndeterminate} />
      )}
    </div>
  );
};

export default SyncProgressBar;
